module.exports = __webpack_public_path__ + "img/45-min.93960b99.jpg";